import React from 'react';
import { Button } from './Button';
import { Phone } from 'lucide-react';
export function CTABand() {
  return <section className="bg-tx-red py-16" data-id="element-69">
      <div className="container mx-auto px-4 text-center" data-id="element-70">
        <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-white mb-8 tracking-tight" data-id="element-71">
          Get Your Free Roof Inspection Today
        </h2>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-72">
          <Button className="bg-white hover:bg-gray-100 text-tx-red font-bold px-8 h-14 rounded-lg text-lg w-full sm:w-auto shadow-lg" data-id="element-73">
            Get My Free Inspection
          </Button>
          <span className="text-white/60 hidden sm:block" data-id="element-74">or</span>
          <a href="tel:8177753540" className="flex items-center gap-2 text-white font-bold text-2xl hover:text-white/90 transition-colors" data-id="element-75">
            <Phone className="w-6 h-6" data-id="element-76" />
            (817) 775-3540
          </a>
        </div>
      </div>
    </section>;
}